import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { Suspense, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { useStore } from 'store/useStore'
import { updatePageHeight } from 'sections/PromoSection/pages/PromoPage/helpers/updatePageHeight'
import { Footer } from 'components/Footer/Footer'
import { FooterNew } from 'components/FooterNew/FooterNew'
import { Header } from 'components/Header/Header'
import { MainLogo } from 'components/MainLogo/MainLogo'
import { isGeDomain } from 'utils/helpers/domains/getDomain'
import { useAsyncEffect } from 'utils/hooks/useAsyncEffect'
import { useResize } from 'utils/hooks/useResize'
import { PromoGeRoutesEnum, PromoRoutesEnum } from 'shared/constants/routes'

import desktopBackground from 'assets/img/promo-page/desktopOverlay.webp'
import desktopBackgroundGe from 'assets/img/promo-page/hero-bg-ny-d.webp'
import mobileBackgroundGe from 'assets/img/promo-page/hero-bg-ny-m.webp'
import tabletBackgroundGe from 'assets/img/promo-page/hero-bg-ny-t.webp'
import loginPageBackground from 'assets/img/promo-page/login-page-background-ge.webp'
import s from './PromoGeneralLayout.module.scss'

export const PromoGeneralLayout = observer(() => {
  const { appStore } = useStore()

  const { isTablet, isMobile } = useResize()
  const location = useLocation()
  const isHomePage = location.pathname === PromoRoutesEnum.root
  const isGeLoginPage = location.pathname === PromoGeRoutesEnum.login

  const backgroundUrl = getBackgroundUrl()

  const layoutClassName = classNames({
    [s.PromoGeneralLayout]: isHomePage,
    [s.PromoGeneralLayoutLoginPage]: !isHomePage && isGeLoginPage,
    [s.PromoSidePageLayout]: !isHomePage && !isGeLoginPage,
  })

  const layoutStyles =
    isHomePage || isGeLoginPage
      ? {
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top center',
          ...(backgroundUrl ? {backgroundImage: `url(${backgroundUrl})`} : {})
        }
      : undefined

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  useEffect(() => {
    updatePageHeight()

    window.addEventListener('resize', updatePageHeight)

    return () => {
      window.removeEventListener('resize', updatePageHeight)
    }
  }, [])

  useEffect(() => {
    updatePageHeight()
  }, [location.pathname])

  useAsyncEffect(async () => {
    appStore.setLoadingApp(true)

    await appStore.bootstrap()

    setTimeout(() => {
      appStore.setLoadingApp(false)
    }, 500)
  }, [])

  function getBackgroundUrl() {
    if (isGeLoginPage) {
      return loginPageBackground
    }
    if (isGeDomain()) {
      if (isMobile) {
        return mobileBackgroundGe
      }
      if (isTablet) {
        return tabletBackgroundGe
      }
      return desktopBackgroundGe
    }
  }

  return (
    <div className={layoutClassName} style={layoutStyles}>
      {!isGeDomain() && <div style={{ backgroundImage: `url(${desktopBackground})` }} className={s.backgroundImage} />}
      <Header />
      <Suspense fallback={<MainLogo />}>
        <Outlet />
      </Suspense>
      {isGeDomain() ? isTablet || isMobile ? null : <FooterNew /> : <Footer />}
    </div>
  )
})
